import React from "react";
import { Alert } from "antd";

import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SETTINGS_ORGANIZATION_BILLING } from "route/constant";

const OverdueBanner = () => {
  const navigate = useNavigate();
  // @ts-ignore
  const { medetails_success } = useSelector((state) => state.users);

  const {
    fetchSubscriptionSuccess,
  }: {
    fetchSubscriptionSuccess: boolean;
    subscriptionsData: Subscription;
  } =
    // @ts-ignore
    useSelector((state) => state.billing);

  return (
    <Alert
      className={
        medetails_success && fetchSubscriptionSuccess ? "ml-[220px]" : ""
      }
      type="warning"
      message={
        <div>
          {" "}
          {/* You have overdue invoice(s), please pay before{" "}
          {subscriptionsData.totalAllowedUsers < 50
            ? new Date(
                new Date(subscriptionsData.expiryDate).getTime() + 7 * 86400000
              ).toDateString()
            : new Date(
                new Date(subscriptionsData.expiryDate).getTime() + 15 * 86400000
              ).toDateString()}{" "}
          to avoid disruption of services. */}
          You have overdue invoice(s), Please clear them to avoid disruption of
          services. [
          <a
            onClick={() => {
              navigate(SETTINGS_ORGANIZATION_BILLING, {
                state: { settingKey: "billing" },
              });
            }}
          >
            Go to Billing
          </a>
          ]
        </div>
      }
      banner
      closable
    />
  );
};

export default OverdueBanner;
